export var buildDecorationSet = function (builders) { return function (_a) {
    var decorationSet = _a.decorationSet, tr = _a.tr;
    return builders.reduce(function (decorationSet, transform) { return transform({ decorationSet: decorationSet, tr: tr }); }, decorationSet);
}; };
export var noop = function (_a) {
    var decorationSet = _a.decorationSet;
    return decorationSet;
};
//# sourceMappingURL=utils.js.map